import React from "react";

/**
 * EventToast — overlay grande quando evento aleatorio ocorre.
 * Auto-dismiss em 5s.
 */
class EventToast extends React.Component {

  constructor(props) {
    super(props);
    this.state = { visible: true };
  }

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({ visible: false });
      if (this.props.onClose) setTimeout(() => this.props.onClose(), 500);
    }, 5000);
  }

  componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
  }

  render() {
    var event = this.props.event;
    if (!event) return null;

    return (
      <div
        onClick={() => this.props.onClose && this.props.onClose()}
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: this.state.visible
            ? 'translate(-50%, -50%) scale(1)'
            : 'translate(-50%, -50%) scale(0.5)',
          opacity: this.state.visible ? 1 : 0,
          transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
          zIndex: 9999,
          background: 'linear-gradient(135deg, #FFD700 0%, #FF6B6B 100%)',
          padding: '40px 60px',
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.4), 0 0 100px rgba(255,215,0,0.6)',
          textAlign: 'center',
          color: '#fff',
          textShadow: '0 2px 4px rgba(0,0,0,0.3)',
          maxWidth: '90%',
          cursor: 'pointer'
        }}
      >
        <h1 style={{ fontSize: '2.5rem', margin: 0, fontWeight: 800 }}>{event.title}</h1>
        <p style={{ fontSize: '1.2rem', margin: '15px 0 0', maxWidth: '500px' }}>
          {event.description}
        </p>
        <small style={{ display: 'block', marginTop: '20px', opacity: 0.7, fontSize: '0.7rem' }}>
          (clique pra fechar)
        </small>
      </div>
    );
  }
}

export default EventToast;
